import React, { useEffect, useState } from 'react';
import { Box, Grid, Hidden, Typography } from '@material-ui/core';
import useStyles from './style';
import mySimIcon from '../.././images/mySimIcon.png';
import MyEirSimReplacementContainer from './MyEirSimReplacementContainer';
import { getSimEligibilityResponse, getSimChargesResponse } from './simReplacement.util';
import { useApolloClient } from '@apollo/client';
import MyEirActivateSimReplacementContainer from './MyEirActivateSimReplacementContainer';
import ESIMActivationModal from './ESIMActivationModal';
import OrderReplacementSimModal from './OrderReplacementSimModal';

const MyEirSimReplacementTile = ({
    ContactDetails,
    msisdn,
    serviceId,
    simCardType,
    esimStatus,
}) => {
    const classes = useStyles();
    const graphql = useApolloClient();
    const [updateOrderLink, setUpdateOrderLink] = useState('hide');
    const [linkFlag, setLinkFlag] = useState(false);
    const [simCost, setSimCost] = useState(0);
    const [reorderForm, setReorderForm] = useState();
    const [reorderCost, setReorderCost] = useState(0);

    //order OR re-order link

    const getSimEligibilityResponseUtil = async () => {
        await getSimEligibilityResponse({
            graphql,
            serviceId,
            setUpdateOrderLink,
            setLinkFlag,
            setReorderForm,
            setReorderCost,
            esimStatus,
            simCardType,
        });
    };
    //cost charges for sim

    const getSimChargesResponseUtil = async () => {
        await getSimChargesResponse({ graphql, serviceId, setSimCost });
    };

    useEffect(() => {
        getSimEligibilityResponseUtil();
        getSimChargesResponseUtil();
    }, [msisdn]);

    return (
        <Box
            className={
                `simTile ` +
                `${linkFlag ? ` sim-link ` : ''}` +
                `${updateOrderLink === 'Re-order' ? 'block' : ''}`
            }
        >
            <Box>
                <Box className='sim'>
                    {/* Enable eSIM feature */}
                    {JSON.parse(sessionStorage.getItem('LoggedinUserFeatures'))?.filter(
                        feature => feature?.feature_name === 'esim'
                    ).length > 0 ? (
                        <>
                            <Typography variant='subtitle1' className='phonenumber'>
                                {msisdn}
                            </Typography>
                            <Typography
                                variant='overline'
                                component='span'
                                className={classes.simTypeText}
                            >
                                {simCardType === 'ALL_IN_1' ? '(Physical Sim)' : '(eSIM)'}
                            </Typography>
                        </>
                    ) : (
                        <>
                            <Box component='img' src={mySimIcon} alt='mysim' />
                            <Typography variant='subtitle1' className='phonenumber'>
                                {msisdn}
                            </Typography>
                        </>
                    )}
                </Box>

                {JSON.parse(sessionStorage.getItem('LoggedinUserFeatures'))?.filter(
                    feature => feature?.feature_name === 'esim'
                ).length > 0 &&
                    simCardType === 'ESIM' &&
                    updateOrderLink === 'Replace SIM' && (
                        <Box className={classes.QRCodeLink}>
                            <ESIMActivationModal
                                serviceId={serviceId}
                                linkName={'QR code & passcode'}
                                header={'Details of your eSIM'}
                            />
                        </Box>
                    )}
            </Box>
            <Grid
                item
                className={
                    `details-topic-order ` + `${updateOrderLink === 'Re-order' ? 'no-flex' : ''}`
                }
            >
                {simCardType === 'ALL_IN_1' ? (
                    updateOrderLink === 'Order' ? (
                        JSON.parse(sessionStorage.getItem('LoggedinUserFeatures'))?.filter(
                            feature => feature?.feature_name === 'esim'
                        ).length > 0 ? (
                            <OrderReplacementSimModal
                                linkName={
                                    JSON.parse(
                                        sessionStorage.getItem('LoggedinUserFeatures')
                                    )?.filter(feature => feature?.feature_name === 'esim').length >
                                    0
                                        ? 'Replace SIM'
                                        : 'Order'
                                }
                                getSimEligibilityResponse={getSimEligibilityResponseUtil}
                                ContactDetails={ContactDetails}
                                serviceId={serviceId}
                                simCost={simCost}
                                flag={false}
                                simCardType={simCardType}
                            />
                        ) : (
                            <MyEirSimReplacementContainer
                                linkName={
                                    JSON.parse(
                                        sessionStorage.getItem('LoggedinUserFeatures')
                                    )?.filter(feature => feature?.feature_name === 'esim').length >
                                    0
                                        ? 'Replace SIM'
                                        : 'Order'
                                }
                                getSimEligibilityResponse={getSimEligibilityResponseUtil}
                                ContactDetails={ContactDetails}
                                serviceId={serviceId}
                                simCost={simCost}
                                flag={false}
                            />
                        )
                    ) : updateOrderLink === 'Re-order' ? (
                        <>
                            <Box item xs={12} md={12} component='span' className='Activate-SIM'>
                                <MyEirActivateSimReplacementContainer serviceId={serviceId} />
                            </Box>
                            <Box component='span' className='verticalLine'>
                                |
                            </Box>
                            <Box className='tile-reorder'>
                                <MyEirSimReplacementContainer
                                    linkName={'Re-order'}
                                    reorderForm={reorderForm}
                                    ContactDetails={ContactDetails}
                                    serviceId={serviceId}
                                    reorderCost={reorderCost}
                                    flag={true}
                                    getSimEligibilityResponse={getSimEligibilityResponseUtil}
                                />
                            </Box>
                        </>
                    ) : updateOrderLink === 'hide' ? (
                        ''
                    ) : (
                        <Box item xs={12} md={12} component='span' className='Activate-SIM'>
                            <MyEirActivateSimReplacementContainer serviceId={serviceId} />
                        </Box>
                    )
                ) : simCardType === 'ESIM' ? (
                    updateOrderLink === 'Replace SIM' ? (
                        <>
                            <OrderReplacementSimModal
                                linkName={'Replace SIM'}
                                getSimEligibilityResponse={getSimEligibilityResponseUtil}
                                ContactDetails={ContactDetails}
                                serviceId={serviceId}
                                simCost={simCost}
                                flag={false}
                                simCardType={simCardType}
                            />
                        </>
                    ) : updateOrderLink === 'Activate' ? (
                        <ESIMActivationModal
                            serviceId={serviceId}
                            linkName={'Activate'}
                            header={'Activate your eSIM'}
                        />
                    ) : (
                        ''
                    )
                ) : (
                    ''
                )}
            </Grid>
        </Box>
    );
};

export default MyEirSimReplacementTile;
